import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import amountService from "../services/eom-amount-service";
import eomMasterService from "../services/eom-master-service";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";
import "react-datepicker/dist/react-datepicker.css";

const AmountDuePerProfile = ({ selectedRow, onCloseModal }) => {
  const [loading, setLoading] = useState(false);
  const [parentList, setParentList] = useState([]);
  const [parent, setParent] = useState(selectedRow?.payor || "");
  const [groupList, setGroupList] = useState([]);
  const [group, setGroup] = useState(selectedRow?.group || "");
  const [chargeCodeList, setChargeCodeList] = useState([]);
  const [chargeCode, setChargeCode] = useState(selectedRow?.unique || "");
  useEffect(() => {
    getPayors();
    getGroups();
  }, []);

  useEffect(() => {
    if (parent) getGroups(parent);
  }, [parent]);
  useEffect(() => {
    if (group) getChargeCodes(parent, group);
  }, [group]);
  const getPayors = async () => {
    try {
      let resp = await eomMasterService.getPayors();
      if (resp) {
        setParentList(resp);
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting payors. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const getGroups = async (parent) => {
    let totalGroupList = [];
    try {
      totalGroupList = await eomMasterService.getGroupCodes(parent);
      setGroupList(totalGroupList);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting groups. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const getChargeCodes = async (parent, group) => {
    try {
      var codes = await eomMasterService.getUniqueCodes(parent, group);
      setChargeCodeList(codes);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting charge codes. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const [amtDue, setAmtDue] = useState(selectedRow?.amt_due || "");
  const [error, setError] = useState(false);

  const onSubmit = async () => {
    try {
      if (!group.length || !amtDue) {
        setError(true);
        return;
      }
      var data = {
        payor: parent,
        group: group,
        unique: chargeCode,
        amt_due: amtDue,
      };
      if (selectedRow?.id) {
        data["id"] = selectedRow?.id;
        await amountService.updateProfile(data);
      } else {
        await amountService.createProfile(data);
      }
      onCloseModal(true);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="text-xl">{selectedRow?.id ? "Edit" : "Create"} </div>
      <div className="bg-white w-full mx-auto mt-6 mb-4 rounded h-96 ">
        <div className="p-2 text-xs">
          <ul>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Payor
              </label>

              <select
                name="payor"
                aria-label="Select Payor"
                onChange={(e) => setParent(e.target.value)}
                value={parent}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Payor</option>
                {parentList
                  ? parentList.map((item, i) => {
                      return (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      );
                    })
                  : null}
              </select>
             
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Group
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <select
                name="group"
                aria-label="Select group"
                onChange={(e) => setGroup(e.target.value)}
                value={group}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Group</option>
                {groupList?.length > 0
                  ? groupList.map((item, i) => {
                      return (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      );
                    })
                  : null}
              </select>
              {error && group?.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify group
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Charge Code
              </label>

              <select
                name="unique"
                aria-label="Select charge code"
                onChange={(e) => setChargeCode(e.target.value)}
                value={chargeCode}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select charge code</option>
                {chargeCodeList
                  ? chargeCodeList.map((item, i) => {
                      return (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Amount due
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <input
                id="amt_due"
                name="amt_due"
                type="number"
                placeholder="Amount due"
                value={amtDue}
                onChange={(e) => setAmtDue(e.target.value)}
                className={` ${
                  error && amtDue.length === 0 ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && amtDue.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify amount due
                </p>
              )}
            </li>

            <li className="text-center">
              <button
                disabled={loading}
                onClick={() => onSubmit()}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(AmountDuePerProfile)
);
